<template>
  <div>
    <template v-if="time && time.status && !isEdit">
      <div class="pa-2">
        <v-layout wrap>
          <v-flex xs12 sm4 class="text-xs-left text-sm-center pb-2 pt-2">{{ $t(name) }}</v-flex>
          <v-flex xs6 sm4 class="text-xs-center pb-2 pt-2">{{ openat || '00:00' }}</v-flex>
          <v-flex xs6 sm4 class="text-xs-center pb-2 pt-2">
            {{ closeat || '24:00' }}
          </v-flex>
        </v-layout>
      </div>
      <v-divider></v-divider>
    </template>
    <template v-if="isEdit">
      <div class="pa-2" v-if="time">
        <v-layout wrap>
          <v-flex xs12 sm4 class="text-xs-center">
            <v-checkbox
              v-model="time.status"
              color="primary"
              class="mt-0"
              :label="$t(name)"
            ></v-checkbox>
          </v-flex>
          <v-flex xs12 sm4 class="text-xs-center form-control">
            <v-layout wrap>
              <v-flex xs9>
                <time-picker-custom v-model="openat" @input="handleOpenAt()" max="23:59"> </time-picker-custom>
                <!-- <time-picker
                  :key="`openat_${name}`"
                  v-model="openat"
                  full-width
                  format="HH:mm"
                  :placeholder="$t('Time')"
                  :hide-clear-button="true"
                  ref="openTimePicker"
                ></time-picker> -->
              </v-flex>
              <v-flex xs3>
                <v-btn
                  fab
                  flat
                  small
                  color="primary"
                  style="height: 35px; width: 35px"
                  @click="clearOpen()"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm4 class="text-xs-center form-control">
            <v-layout wrap>
              <v-flex xs9>
                <time-picker-custom v-model="closeat" @input="handleCloseAt()"> </time-picker-custom>
                <!-- <time-picker
                  :key="`closeat_${name}`"
                  v-model="closeat"
                  full-width
                  format="HH:mm"
                  :placeholder="$t('Time')"
                  :hide-clear-button="true"
                  ref="closeTimePicker"
                ></time-picker> -->
              </v-flex>
              <v-flex xs3>
                <v-btn
                  fab
                  flat
                  small
                  color="primary"
                  style="height: 35px; width: 35px"
                  @click="clearClose()"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>
      <v-divider></v-divider>
    </template>
  </div>
</template>

<script>
// import TimePicker from '@/components/elements/TimePicker.vue'
import TimePickerCustom from '@/components/elements/TimePickerCustom.vue'
import dayjs from 'dayjs'
const today = dayjs().format('YYYY-MM-DD')
export default {
  inject: ['$validator'],
  props: ['value', 'name', 'isEdit'],
  components: {
    // TimePicker,
    TimePickerCustom
  },
  data() {
    return {
      time: null,
      showOpenat: false,
      showCloseat: false
    }
  },
  computed: {
    openat: {
      get() {
        if (this.time && this.time.openat) {
          return this.time.openat.split('+')[0]
        } else {
          return ''
        }
      },
      set(value) {
        if (value) {
          this.time.openat = value + '+07'
        } else {
          this.time.openat = null
        }
      }
    },
    closeat: {
      get() {
        if (this.time && this.time.closeat) {
          return this.time.closeat.split('+')[0]
        } else {
          return ''
        }
      },
      set(value) {
        if (value) {
          this.time.closeat = value + '+07'
        } else {
          this.time.closeat = null
        }
      }
    }
  },
  mounted: function() {
    this.time = this.value
  },
  watch: {
    value: function(newVal, oldVal) {
      this.time = this.value
    }
  },
  methods: {
    handleOpenAt() {
      if (this.closeat && this.closeat.slice(0, 5) !== '24:00' && this.openat) {
        const open = dayjs(`${today} ${this.openat.split(0, 5)}`)
        const close = dayjs(`${today} ${this.closeat.split(0, 5)}`)
        this.closeat = open > close ? null : this.closeat
      }
    },
    handleCloseAt() {
      if (this.closeat && this.closeat.slice(0, 5) !== '24:00' && this.openat) {
        const open = dayjs(`${today} ${this.openat.split(0, 5)}`)
        const close = dayjs(`${today} ${this.closeat.split(0, 5)}`)
        this.openat = open > close ? null : this.openat
      }
    },
    clearOpen() {
      this.openat = null
    },
    clearClose() {
      this.closeat = null
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/billing/OpenTimeBotItem.vue